<template>
  <v-dialog v-model="dialog" width="500">
    <v-card>
      <v-card-title>{{ $t("messages.message") }}</v-card-title>
      <v-card-text>
        <v-form ref="form">
          <v-text-field v-model="model.title" :label="$t('messages.title')" />
          <v-text-field v-model="model.location" :label="$t('messages.location')" />
          <FCCDateTime :source="this.model" propertyName="start" :label="this.$t('messages.start')" />
          <FCCDateTime :source="this.model" propertyName="end" :label="this.$t('messages.end')" />
          <v-textarea :label="$t('messages.text')" v-model="model.text"></v-textarea>
          <v-checkbox v-model="model.public" :label="$t('messages.public')" />
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn @click="this.save" color="success">
          {{ $t("ctrl.save") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import {
    VCard,
    VTooltip,
    VForm,
    VTextField,
    VCardActions,
    VCardText,
    VSelect,
    VDatePicker,
    VMenu,
    VIcon,
    VTextarea,
    VDataTable,
    VAutocomplete,
    VCheckbox,
    VAlert,
    VDialog
  } from 'vuetify/lib'
  import FCCDateTime from '../widgets/FCCDateTime'
  import fccapi from '../fccapi.js'

  export default {
    name: 'MessageEditDialog',
    data: () => ({
      dialog: false,
      model: {},
    }),
    computed: {
      applicationTypes: function () {
        return [this.$t("application.individual"), this.$t("application.tandem"), this.$t("application.relay")]
          .map((e, i)=>{return {id: i, name: e}})
      },
      rules: function() {
        return {
          required: value =>  !!value || this.$t('registration.required')
        }
      }
    },
    props: {
      source: String,
      reload: Function
    },
    components: {
      VCard,
      VTooltip,
      VForm,
      VTextField,
      VCardActions,
      VCardText,
      VSelect,
      VIcon,
      VDatePicker,
      VMenu,
      VDataTable,
      VTextarea,
      VAutocomplete,
      VCheckbox,
      VAlert,
      VDialog,
      FCCDateTime
    },
    methods: {
      show: function(obj){
        this.model = JSON.parse(JSON.stringify(obj));
        this.dialog = true;
      },
      save: function(){
        if(this.model.id != undefined){
          console.log("save "+this.model.id)
          fccapi.post(`messages/${this.model.id}`, this.model).then(d => {
            this.dialog = false;
            this.reload();
          }).catch(e => {
            console.log(e)
          })
        }else{
          this.model.CompetitionId = this.$store.getters.competitionId
          fccapi.post(`messages`, this.model).then(d => {
            this.dialog = false;
            this.reload();
          }).catch(e => {
            console.log(e)
          })
        }
      }
    },
    mounted: function(){
      
    }
  }
</script>